
import {initWebComponent} from "@/helpers/web-component-helper";
import {clearFiltersValues} from "@/helpers/filter/filter-settings-helper";

export class LayerInfoFilterSettingsResetButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<button class="btn btn-outline-danger btn-sm btn-block">Reset</button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            clearFiltersValues()
        })
    }
}

